export default "__VITE_ASSET__0205512e__"